export default __webpack_public_path__ + "static/media/Group21.afef7f46.png";